import { apiClient } from "../../../lib/api-client"
import { AiGeneratedVacancyDto } from "./vacancy-service"

export interface SageOriginMetadataDto {
  companyCode: string
  companyRuleCode: string
  positionCode: string
  positionId: number
  rawPayload?: string | null
}

export interface Sage300Vacancy {
  positionId: number
  positionCode: string
  description: string
  positionStatus: string
  companyCode: string
  companyRuleCode: string
}

export enum Sage300SubmissionStatus {
  Pending = 0,
  EmployeePushInProgress = 1,
  EmployeeCreated = 2,
  FailedEmployeePush = 5,
}

export const Sage300SubmissionStatusLabels: Record<Sage300SubmissionStatus, string> = {
  [Sage300SubmissionStatus.Pending]: "Pending",
  [Sage300SubmissionStatus.EmployeePushInProgress]: "Push In Progress",
  [Sage300SubmissionStatus.EmployeeCreated]: "Employee Created",
  [Sage300SubmissionStatus.FailedEmployeePush]: "Push Failed",
}

export interface Sage300SubmissionStatusDto {
  employeeId: string
  entityCode: string | null
  status: Sage300SubmissionStatus
  lastErrorPayload: string | null
  updatedAt: string | null
}

export interface Sage300SubmitEmployeeRequest {
  companyCode: string
  companyRuleCode: string
  employeeCode: string
}

export interface Sage300SubmitEmployeeResult {
  success: boolean
  message: string
  entityCode: string | null
}

export async function getSage300Vacancies(
  organizationId: string,
): Promise<Sage300Vacancy[]> {
  const res = await apiClient.get<Sage300Vacancy[]>(
    `/organizations/${organizationId}/sage300/vacancies`,
  )
  return res.data
}

export async function generateVacancyFromSage300Position(
  organizationId: string,
  positionId: number,
): Promise<AiGeneratedVacancyDto> {
  const res = await apiClient.post<AiGeneratedVacancyDto>(
    `/organizations/${organizationId}/sage300/vacancies/${positionId}/generate-vacancy`,
  )
  return res.data
}

export async function submitEmployeeToSage300(
  organizationId: string,
  employeeId: string,
  request: Sage300SubmitEmployeeRequest,
): Promise<Sage300SubmitEmployeeResult> {
  const res = await apiClient.post<Sage300SubmitEmployeeResult>(
    `/organizations/${organizationId}/sage300/submit/${employeeId}`,
    request,
  )
  return res.data
}

export async function getSage300SubmissionStatus(
  organizationId: string,
  employeeId: string,
): Promise<Sage300SubmissionStatusDto> {
  const res = await apiClient.get<Sage300SubmissionStatusDto>(
    `/organizations/${organizationId}/sage300/submission/${employeeId}/status`,
  )
  return res.data
}
